import { isNil } from "lodash";
import {
  TotalAvailabilityMetricData,
  WorkforceMetrics as WorkforceMetricsType,
  WorkforceMetricsMode
} from "PFApp/booking/types";

export const calculateMetricValue = (
  mode: WorkforceMetricsMode,
  metricsData?: WorkforceMetricsType
): number | undefined => {
  const metric = metricsData?.[mode];
  if (isNil(metric)) {
    return undefined;
  }
  switch (mode) {
    case WorkforceMetricsMode.BillableUtilization:
    case WorkforceMetricsMode.TotalUtilization:
      return Math.round(((metric as number) || 0) * 100);
    case WorkforceMetricsMode.TotalAvailability: {
      const { availableMinutes, nominalWorkingMinutes } = metric as TotalAvailabilityMetricData;
      if (isNil(availableMinutes) || isNil(nominalWorkingMinutes) || nominalWorkingMinutes === 0) {
        return undefined;
      }
      return Math.round((availableMinutes / nominalWorkingMinutes) * 100);
    }
  }
};

export const getMetricDisplayValue = (
  mode: WorkforceMetricsMode,
  metricsData: WorkforceMetricsType = {}
): string | undefined => {
  const metric = metricsData[mode];
  if (isNil(metric)) {
    return undefined;
  }
  switch (mode) {
    case WorkforceMetricsMode.BillableUtilization:
    case WorkforceMetricsMode.TotalUtilization:
      return String(Math.round(((metric as number) || 0) * 100));
    case WorkforceMetricsMode.TotalAvailability: {
      const { availableMinutes } = metric as TotalAvailabilityMetricData;
      if (isNil(availableMinutes)) {
        return undefined;
      }
      return Number(Math.round(availableMinutes / 60)).toLocaleString("en-US");
    }
  }
};
